var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGooglePay = function SvgIconGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Icon Google Pay",
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-google-pay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.596 8.794v5.276h-1.674V1.04h4.44a4.014 4.014 0 0 1 2.874 1.128 3.626 3.626 0 0 1 1.2 2.75 3.61 3.61 0 0 1-1.2 2.765c-.776.74-1.735 1.11-2.875 1.11h-2.765Zm0-6.15v4.549h2.807a2.213 2.213 0 0 0 1.656-.674 2.22 2.22 0 0 0 0-3.185 2.183 2.183 0 0 0-1.656-.691h-2.807Zm10.696 2.22c1.238 0 2.214.33 2.93.991.716.662 1.074 1.568 1.073 2.72v5.495h-1.6v-1.237h-.074c-.693 1.019-1.615 1.528-2.765 1.528-.982 0-1.804-.291-2.465-.873a2.788 2.788 0 0 1-.992-2.184c0-.922.348-1.656 1.046-2.2.697-.545 1.628-.819 2.792-.82.994 0 1.813.182 2.456.546v-.383a1.905 1.905 0 0 0-.691-1.481 2.37 2.37 0 0 0-1.616-.61c-.935 0-1.675.394-2.22 1.183l-1.474-.929c.811-1.164 2.011-1.746 3.6-1.746Zm-2.165 6.477a1.337 1.337 0 0 0 .555 1.091c.37.292.83.446 1.3.437a2.669 2.669 0 0 0 1.883-.782c.555-.522.832-1.134.832-1.837-.522-.416-1.25-.624-2.183-.624-.68 0-1.247.164-1.701.492-.458.333-.686.737-.686 1.223Zm15.358-6.186L39.895 18h-1.728l2.075-4.495-3.676-8.35h1.82l2.656 6.404h.037l2.583-6.404h1.823Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.829 7.656c0-.51-.043-1.02-.129-1.522H7.64v2.883h4.044a3.463 3.463 0 0 1-1.495 2.275v1.871h2.413c1.413-1.302 2.227-3.229 2.227-5.507Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.641 14.972c2.02 0 3.721-.664 4.962-1.807l-2.413-1.872c-.672.456-1.537.715-2.549.715-1.952 0-3.61-1.316-4.202-3.09H.953v1.93a7.486 7.486 0 0 0 6.688 4.123Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44 8.918a4.485 4.485 0 0 1 0-2.865V4.124H.952a7.486 7.486 0 0 0 0 6.723L3.44 8.918Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.641 2.963a4.064 4.064 0 0 1 2.872 1.123l2.136-2.137A7.192 7.192 0 0 0 7.641 0 7.486 7.486 0 0 0 .953 4.124L3.44 6.053c.593-1.774 2.25-3.09 4.202-3.09Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-google-pay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.156)",
    d: "M0 0h45.327v18H0z"
  })))));
};
export default SvgIconGooglePay;